/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCascaderProps } from './type';

export const cascaderDefaultProps: TdCascaderProps = {
  checkStrictly: false,
  closeBtn: true,
  lazy: false,
  loadCompleted: false,
  options: [],
  overlayProps: {},
  placeholder: '选择选项',
  subTitles: [],
  theme: 'step',
  visible: false,
};
